/**
 * Update date: 06-06-2023
 * Screen 2055.2
 */
import Collapse from 'app/components/Collapse';
import DateOptions from 'app/components/DateOptions';
import PopupSelectCommonCode from 'app/components/PopupCommon/PopupSelectCommonCode';
import PopupSelectProduct from 'app/components/PopupCommon/PopupSelectProduct';
import PopupSelectProductGroup from 'app/components/PopupCommon/PopupSelectProductGroup';
import PopupSelectZone from 'app/components/PopupCommon/PopupSelectZone';
import Form from 'devextreme-react/form';
import useDictionary from 'hooks/useDictionary';
import useFormatTime from 'hooks/useFormatTime';
import { uniqBy } from 'lodash';
import moment from 'moment';
import React, { forwardRef, useState } from 'react';
import { useInquiresOfScheduled } from '..';
const listTypeCommon = {
  zone: {
    codeType: 'ZO',
    title: 'Zone',
  },
  product: {
    codeType: 'PD',
    title: 'Search Product',
  },
  productGroup: {
    codeType: 'PG',
    title: 'Search ProductGroup',
  },
  largeCategories: {
    codeType: 'LC',
    title: 'Search Large Category',
  },
  mediumCategories: {
    codeType: 'MC',
    title: 'Search Medium Category',
  },
  smallCategories: {
    codeType: 'SC',
    title: 'Search Small Category',
  },
  subCategories: {
    codeType: 'UC',
    title: 'Search Sub Category',
  },
  reason: {
    codeType: 'XR',
    title: 'Search Reason',
  },
};

const FormSearch = (props, ref) => {
  const context: any = useInquiresOfScheduled();
  const { params, setParams, refetchData } = context;
  const [showPopupByType, setShowPopupByType] = useState('');

  const { DateFormat } = useFormatTime();
  const { t }: any = useDictionary({
    programId: '2055.2',
  });
  /**
   * on submit
   *
   * @return {*}
   */
  const onSubmit = () => {
    const isValid = ref?.current?.instance?.validate()?.isValid;
    if (isValid === false) return;
    const data = {
      largeCategories: params?.formStore.largeCategories.map(
        (map: any) => map?.code,
      ),
      mediumCategories: params?.formStore.mediumCategories.map(
        (map: any) => map?.code,
      ),
      smallCategories: params?.formStore.smallCategories.map(
        (map: any) => map?.code,
      ),
      subCategories: params?.formStore.subCategories.map(
        (map: any) => map?.code,
      ),
      reasons: params?.formStore.reason.map((map: any) => map?.code),
      productIds: params?.formStore.product.map((map: any) => map?.productId),
      productGroupIds: params?.formStore.productGroup.map(
        (map: any) => map?.productGroupId,
      ),
      zoneIds: params?.formStore.zone.map((map: any) => map?.zoneId),
      fromDate: params.fromDate
        ? moment(params.fromDate).format('YYYY-MM-DD')
        : null,
      toDate: params.toDate ? moment(params.toDate).format('YYYY-MM-DD') : null,
      status: params.status,
    };
    refetchData({
      data,
    });
  };
  // Onchange date when choose date option
  const onChangeDate = (fromDateValue, toDateValue) => {
    if (!fromDateValue || !toDateValue) return;
    ref?.current?.instance?.updateData('fromDate', fromDateValue);
    ref?.current?.instance?.updateData('toDate', toDateValue);
  };
  /**
   * on field data changed
   *
   * @param {*} e
   */
  const onFieldDataChanged = e => {
    switch (e?.dataField) {
      case 'fromDate':
        if (params.toDate && e?.value && e?.value > params.toDate)
          ref?.current?.instance.updateData('toDate', null);
        break;
      case 'toDate':
        if (params.fromDate && e?.value && e?.value < params.fromDate)
          ref?.current?.instance.updateData('fromDate', null);
        break;
      default:
        break;
    }
  };
  /**
   * render popup by type
   *
   * @param {string} popupType
   * @return {*}
   */
  const getPopupByType = (popupType: string) => {
    switch (popupType) {
      case 'zone':
        return (
          <PopupSelectZone
            visible={!!listTypeCommon?.[popupType]?.codeType}
            text={params?.[popupType]}
            onHiding={() => setShowPopupByType('')}
            mode="multiple"
            onSubmit={data => updateStore(popupType, data, 'zoneId')}
          />
        );
      case 'product':
        return (
          <PopupSelectProduct
            visible={!!listTypeCommon?.[popupType]?.codeType}
            text={params?.[popupType]}
            onHiding={() => setShowPopupByType('')}
            mode="multiple"
            onSubmit={data => updateStore(popupType, data, 'productId')}
          />
        );
      case 'productGroup':
        return (
          <PopupSelectProductGroup
            visible={!!listTypeCommon?.[popupType]?.codeType}
            text={params?.[popupType]}
            onHiding={() => setShowPopupByType('')}
            mode="multiple"
            onSubmit={data => updateStore(popupType, data, 'productGroupId')}
          />
        );
      case 'largeCategories':
      case 'mediumCategories':
      case 'smallCategories':
      case 'subCategories':
      case 'reason':
        return (
          <PopupSelectCommonCode
            visible={!!listTypeCommon?.[popupType]?.codeType}
            text={params?.[popupType]}
            codeType={listTypeCommon?.[popupType]?.codeType}
            mode="multiple"
            onHiding={() => setShowPopupByType('')}
            onSubmit={data => updateStore(popupType, data, 'code')}
          />
        );
      default:
        return null;
    }
  };

  /**
   * on update store
   *
   * @param {*} popupType
   * @param {*} data
   * @param {*} [key=false]
   */
  const updateStore = (popupType, data, key: any = false) => {
    const filterData = uniqBy(
      [...params?.formStore?.[popupType], ...data],
      key,
    );
    const newStore = { ...params?.formStore, [popupType]: filterData };
    setParams(preState => ({
      ...preState,
      [popupType]: '',
      formStore: newStore,
    }));
    setShowPopupByType('');
  };
  /**
   * on remove store
   *
   * @param {*} popupType
   * @param {*} index
   */
  const removeStore = (popupType, index) => {
    let newStore;
    if (index === -1) {
      setParams(preState => ({
        ...preState,
        formStore: {
          ...preState?.formStore,
          [popupType]: [],
        },
      }));
    } else {
      const l = [...params?.formStore[popupType]];
      newStore = [...l.slice(0, index), ...l.slice(index + 1)];
      setParams(preState => ({
        ...preState,
        formStore: {
          ...preState?.formStore,
          [popupType]: newStore,
        },
      }));
    }
  };
  /**
   * render search
   *
   * @param {*} { name }
   * @return {*}
   */
  const Search = ({ name }) => {
    return (
      <>
        <DateOptions
          onChangeValue={(fromDate, toDate) => onChangeDate(fromDate, toDate)}
        />
        <Form
          ref={ref}
          formData={params}
          showColonAfterLabel={false}
          items={[
            {
              dataField: 'fromDate',
              editorType: 'dxDateBox',
              label: {
                text: t('From Date'),
              },
              editorOptions: {
                displayFormat: DateFormat,
              },
            },
            {
              dataField: 'toDate',
              editorType: 'dxDateBox',
              label: {
                text: t('End Date'),
              },
              editorOptions: {
                displayFormat: DateFormat,
              },
            },
            {
              label: { text: t('Zone') },
              dataField: 'zone',
              editorType: 'dxTextBox',
              editorOptions: {
                onEnterKey: () => setShowPopupByType('zone'),
                buttons: [
                  {
                    name: 'data1',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: params?.formStore?.zone[0]?.zoneName,
                      onClick: () => removeStore('zone', 0),
                      visible: !!params?.formStore?.zone[0]?.zoneId,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'data2',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: params?.formStore?.zone[1]?.zoneName,
                      onClick: () => removeStore('zone', 1),
                      visible: !!params?.formStore?.zone[1]?.zoneId,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'dataMore',
                    location: 'before',
                    options: {
                      text: `+ ${params?.formStore?.zone?.length - 2} ${t(
                        'more',
                      )}`,
                      visible: params?.formStore?.zone?.length > 2,
                    },
                  },
                  {
                    name: 'clearAll',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'close',
                      visible: !!params?.formStore?.zone?.length,
                      onClick: () => removeStore('zone', -1),
                    },
                  },
                  {
                    name: 'search',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'search',
                      onClick: () => setShowPopupByType('zone'),
                    },
                  },
                ],
              },
            },
            {
              label: { text: t('Reason') },
              dataField: 'reason',
              editorType: 'dxTextBox',
              editorOptions: {
                onEnterKey: () => setShowPopupByType('reason'),
                buttons: [
                  {
                    name: 'data1',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: params?.formStore?.reason[0]?.name,
                      onClick: () => removeStore('reason', 0),
                      visible: !!params?.formStore?.reason[0]?.code,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'data2',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: params?.formStore?.reason[1]?.name,
                      onClick: () => removeStore('reason', 1),
                      visible: !!params?.formStore?.reason[1]?.code,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'dataMore',
                    location: 'before',
                    options: {
                      text: `+ ${params?.formStore?.reason?.length - 2} ${t(
                        'more',
                      )}`,
                      visible: params?.formStore?.reason?.length > 2,
                    },
                  },
                  {
                    name: 'clearAll',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'close',
                      visible: !!params?.formStore?.reason?.length,
                      onClick: () => removeStore('reason', -1),
                    },
                  },
                  {
                    name: 'search',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'search',
                      onClick: () => setShowPopupByType('reason'),
                    },
                  },
                ],
              },
            },
            {
              label: { text: t('Status') },
              dataField: 'status',
              editorType: 'dxSelectBox',
              editorOptions: {
                displayExpr: 'label',
                valueExpr: 'value',
                defaultValue: '',
                items: [
                  { label: t('All'), value: '2' },
                  { label: t('Pending'), value: '0' },
                  { label: t('Fixed'), value: '1' },
                ],
              },
            },
          ]}
          labelLocation="top"
          onFieldDataChanged={onFieldDataChanged}
          colCount={4}
        ></Form>
      </>
    );
  };
  /**
   * render advanced search
   *
   * @param {*} { name }
   * @return {*}
   */
  const AdvancedSearch = ({ name }) => {
    return (
      <>
        <Form
          formData={params}
          showColonAfterLabel={false}
          items={[
            {
              label: { text: t('Large Category') },
              dataField: 'largeCategories',
              editorType: 'dxTextBox',
              editorOptions: {
                onEnterKey: () => setShowPopupByType('largeCategories'),
                buttons: [
                  {
                    name: 'data1',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: params?.formStore?.largeCategories[0]?.name,
                      onClick: () => removeStore('largeCategories', 0),
                      visible: !!params?.formStore?.largeCategories[0]?.code,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'data2',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: params?.formStore?.largeCategories[1]?.name,
                      onClick: () => removeStore('largeCategories', 1),
                      visible: !!params?.formStore?.largeCategories[1]?.code,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'dataMore',
                    location: 'before',
                    options: {
                      text: `+ ${
                        params?.formStore?.largeCategories?.length - 2
                      } ${t('more')}`,
                      visible: params?.formStore?.largeCategories?.length > 2,
                    },
                  },
                  {
                    name: 'clearAll',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'close',
                      visible: !!params?.formStore?.largeCategories?.length,
                      onClick: () => removeStore('largeCategories', -1),
                    },
                  },
                  {
                    name: 'search',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'search',
                      onClick: () => setShowPopupByType('largeCategories'),
                    },
                  },
                ],
              },
            },
            {
              label: { text: t('Medium Category') },
              dataField: 'mediumCategories',
              editorType: 'dxTextBox',
              editorOptions: {
                onEnterKey: () => setShowPopupByType('mediumCategories'),
                buttons: [
                  {
                    name: 'data1',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: params?.formStore?.mediumCategories[0]?.name,
                      onClick: () => removeStore('mediumCategories', 0),
                      visible: !!params?.formStore?.mediumCategories[0]?.code,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'data2',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: params?.formStore?.mediumCategories[1]?.name,
                      onClick: () => removeStore('mediumCategories', 1),
                      visible: !!params?.formStore?.mediumCategories[1]?.code,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'dataMore',
                    location: 'before',
                    options: {
                      text: `+ ${
                        params?.formStore?.mediumCategories?.length - 2
                      } ${t('more')}`,
                      visible: params?.formStore?.mediumCategories?.length > 2,
                    },
                  },
                  {
                    name: 'clearAll',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'close',
                      visible: !!params?.formStore?.mediumCategories?.length,
                      onClick: () => removeStore('mediumCategories', -1),
                    },
                  },
                  {
                    name: 'search',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'search',
                      onClick: () => setShowPopupByType('mediumCategories'),
                    },
                  },
                ],
              },
            },
            {
              label: { text: t('Product Group') },
              dataField: 'productGroup',
              editorType: 'dxTextBox',
              editorOptions: {
                onEnterKey: () => setShowPopupByType('productGroup'),
                buttons: [
                  {
                    name: 'data1',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: params?.formStore?.productGroup[0]?.productGroupNm,
                      onClick: () => removeStore('productGroup', 0),
                      visible:
                        !!params?.formStore?.productGroup[0]?.productGroupId,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'data2',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: params?.formStore?.productGroup[1]?.productGroupNm,
                      onClick: () => removeStore('productGroup', 1),
                      visible:
                        !!params?.formStore?.productGroup[1]?.productGroupId,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'dataMore',
                    location: 'before',
                    options: {
                      text: `+ ${
                        params?.formStore?.productGroup?.length - 2
                      } ${t('more')}`,
                      visible: params?.formStore?.productGroup?.length > 2,
                    },
                  },
                  {
                    name: 'clearAll',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'close',
                      visible: !!params?.formStore?.productGroup?.length,
                      onClick: () => removeStore('productGroup', -1),
                    },
                  },
                  {
                    name: 'search',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'search',
                      onClick: () => setShowPopupByType('productGroup'),
                    },
                  },
                ],
              },
            },
            {
              label: { text: t('Small Category') },
              dataField: 'smallCategories',
              editorType: 'dxTextBox',
              editorOptions: {
                onEnterKey: () => setShowPopupByType('smallCategories'),
                buttons: [
                  {
                    name: 'data1',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: params?.formStore?.smallCategories[0]?.name,
                      onClick: () => removeStore('smallCategories', 0),
                      visible: !!params?.formStore?.smallCategories[0]?.code,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'data2',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: params?.formStore?.smallCategories[1]?.name,
                      onClick: () => removeStore('smallCategories', 1),
                      visible: !!params?.formStore?.smallCategories[1]?.code,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'dataMore',
                    location: 'before',
                    options: {
                      text: `+ ${
                        params?.formStore?.smallCategories?.length - 2
                      } ${t('more')}`,
                      visible: params?.formStore?.smallCategories?.length > 2,
                    },
                  },
                  {
                    name: 'clearAll',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'close',
                      visible: !!params?.formStore?.smallCategories?.length,
                      onClick: () => removeStore('smallCategories', -1),
                    },
                  },
                  {
                    name: 'search',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'search',
                      onClick: () => setShowPopupByType('smallCategories'),
                    },
                  },
                ],
              },
            },
            {
              label: { text: t('Sub Category') },
              dataField: 'subCategories',
              editorType: 'dxTextBox',
              editorOptions: {
                onEnterKey: () => setShowPopupByType('subCategories'),
                buttons: [
                  {
                    name: 'data1',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: params?.formStore?.subCategories[0]?.name,
                      onClick: () => removeStore('subCategories', 0),
                      visible: !!params?.formStore?.subCategories[0]?.code,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'data2',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: params?.formStore?.subCategories[1]?.name,
                      onClick: () => removeStore('subCategories', 1),
                      visible: !!params?.formStore?.subCategories[1]?.code,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'dataMore',
                    location: 'before',
                    options: {
                      text: `+ ${
                        params?.formStore?.subCategories?.length - 2
                      } ${t('more')}`,
                      visible: params?.formStore?.subCategories?.length > 2,
                    },
                  },
                  {
                    name: 'clearAll',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'close',
                      visible: !!params?.formStore?.subCategories?.length,
                      onClick: () => removeStore('subCategories', -1),
                    },
                  },
                  {
                    name: 'search',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'search',
                      onClick: () => setShowPopupByType('subCategories'),
                    },
                  },
                ],
              },
            },
            {
              label: { text: t('Product') },
              dataField: 'product',
              editorType: 'dxTextBox',
              editorOptions: {
                onEnterKey: () => setShowPopupByType('product'),
                buttons: [
                  {
                    name: 'data1',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: params?.formStore?.product[0]?.productNm,
                      onClick: () => removeStore('product', 0),
                      visible: !!params?.formStore?.product[0]?.productId,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'data2',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: params?.formStore?.product[1]?.productNm,
                      onClick: () => removeStore('product', 1),
                      visible: !!params?.formStore?.product[1]?.productId,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'dataMore',
                    location: 'before',
                    options: {
                      text: `+ ${params?.formStore?.product?.length - 2} ${t(
                        'more',
                      )}`,
                      visible: params?.formStore?.product?.length > 2,
                    },
                  },
                  {
                    name: 'clearAll',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'close',
                      visible: !!params?.formStore?.product?.length,
                      onClick: () => removeStore('product', -1),
                    },
                  },
                  {
                    name: 'search',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'search',
                      onClick: () => setShowPopupByType('product'),
                    },
                  },
                ],
              },
            },
          ]}
          labelLocation="top"
          colCount={3}
        ></Form>
      </>
    );
  };
  return (
    <div>
      <Collapse onSubmit={onSubmit}>
        <Search name={t('Search')} />
        <AdvancedSearch name={t('Advanced Search')} />
      </Collapse>
      {getPopupByType(showPopupByType)}
    </div>
  );
};

export default forwardRef(FormSearch);
